let { View } = window.App;


View.addHook( 'init', v => {
    v.$( '.js-flippable' ).each( function(){
        let $this = $( this );
        $this.find( '.js-flippable__trigger' ).on( 'click', function( e ){
            e.preventDefault();
            $this.toggleClass( '__flipped' );
        } )
    } );
} )



// WEBPACK FOOTER //
// ./resources/js/modules/flippable.js